"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-check-deposit.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-check-deposit.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkProcessorToJSON = exports.checkProcessorFromJSON = exports.CheckDepositPaymentContext = exports.CheckProcessor = void 0;
const check_return_context_1 = require("./check-return-context");
const protobufPackage = 'com.step.common.proto';
var CheckProcessor;
(function (CheckProcessor) {
    CheckProcessor["INVALID_CHECK_PROCESSOR"] = "INVALID_CHECK_PROCESSOR";
    CheckProcessor["URBAN_FT"] = "URBAN_FT";
    CheckProcessor["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CheckProcessor || (exports.CheckProcessor = CheckProcessor = {}));
function createBaseCheckDepositPaymentContext() {
    return {
        accountNumberLast4: '',
        routingNumber: '',
        checkNumber: '',
        frontImageId: '',
        backImageId: '',
        note: '',
        operatorNote: '',
        returnContext: undefined,
        holdDurationDays: undefined,
        releaseFundsAfterMs: undefined,
        operatorUsername: undefined,
        operatorActionAtMs: undefined,
        processedAtMs: undefined,
        processorTransactionId: undefined,
        processor: CheckProcessor.INVALID_CHECK_PROCESSOR,
    };
}
exports.CheckDepositPaymentContext = {
    fromJSON(object) {
        const message = {
            frontImageId: isSet(object.frontImageId) ? globalThis.String(object.frontImageId) : '',
            backImageId: isSet(object.backImageId) ? globalThis.String(object.backImageId) : '',
        };
        if (isSet(object.accountNumberLast4)) {
            message.accountNumberLast4 = globalThis.String(object.accountNumberLast4);
        }
        if (isSet(object.routingNumber)) {
            message.routingNumber = globalThis.String(object.routingNumber);
        }
        if (isSet(object.checkNumber)) {
            message.checkNumber = globalThis.String(object.checkNumber);
        }
        if (isSet(object.note)) {
            message.note = globalThis.String(object.note);
        }
        if (isSet(object.operatorNote)) {
            message.operatorNote = globalThis.String(object.operatorNote);
        }
        if (isSet(object.returnContext)) {
            message.returnContext = check_return_context_1.CheckReturnContext.fromJSON(object.returnContext);
        }
        if (isSet(object.holdDurationDays)) {
            message.holdDurationDays = globalThis.Number(object.holdDurationDays);
        }
        if (isSet(object.releaseFundsAfterMs)) {
            message.releaseFundsAfterMs = globalThis.String(object.releaseFundsAfterMs);
        }
        if (isSet(object.operatorUsername)) {
            message.operatorUsername = globalThis.String(object.operatorUsername);
        }
        if (isSet(object.operatorActionAtMs)) {
            message.operatorActionAtMs = globalThis.String(object.operatorActionAtMs);
        }
        if (isSet(object.processedAtMs)) {
            message.processedAtMs = globalThis.String(object.processedAtMs);
        }
        if (isSet(object.processorTransactionId)) {
            message.processorTransactionId = globalThis.String(object.processorTransactionId);
        }
        if (isSet(object.processor)) {
            message.processor = checkProcessorFromJSON(object.processor);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountNumberLast4 !== undefined && message.accountNumberLast4 !== '') {
            obj.accountNumberLast4 = message.accountNumberLast4;
        }
        if (message.routingNumber !== undefined && message.routingNumber !== '') {
            obj.routingNumber = message.routingNumber;
        }
        if (message.checkNumber !== undefined && message.checkNumber !== '') {
            obj.checkNumber = message.checkNumber;
        }
        if (message.frontImageId !== '') {
            obj.frontImageId = message.frontImageId;
        }
        if (message.backImageId !== '') {
            obj.backImageId = message.backImageId;
        }
        if (message.note !== undefined && message.note !== '') {
            obj.note = message.note;
        }
        if (message.operatorNote !== undefined && message.operatorNote !== '') {
            obj.operatorNote = message.operatorNote;
        }
        if (message.returnContext !== undefined) {
            obj.returnContext = check_return_context_1.CheckReturnContext.toJSON(message.returnContext);
        }
        if (message.holdDurationDays !== undefined) {
            obj.holdDurationDays = Math.round(message.holdDurationDays);
        }
        if (message.releaseFundsAfterMs !== undefined) {
            obj.releaseFundsAfterMs = message.releaseFundsAfterMs;
        }
        if (message.operatorUsername !== undefined) {
            obj.operatorUsername = message.operatorUsername;
        }
        if (message.operatorActionAtMs !== undefined) {
            obj.operatorActionAtMs = message.operatorActionAtMs;
        }
        if (message.processedAtMs !== undefined) {
            obj.processedAtMs = message.processedAtMs;
        }
        if (message.processorTransactionId !== undefined) {
            obj.processorTransactionId = message.processorTransactionId;
        }
        if (message.processor !== undefined &&
            message.processor !== CheckProcessor.INVALID_CHECK_PROCESSOR) {
            obj.processor = checkProcessorToJSON(message.processor);
        }
        return obj;
    },
    create(base) {
        return exports.CheckDepositPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckDepositPaymentContext();
        message.accountNumberLast4 = object.accountNumberLast4 ?? '';
        message.routingNumber = object.routingNumber ?? '';
        message.checkNumber = object.checkNumber ?? '';
        message.frontImageId = object.frontImageId ?? '';
        message.backImageId = object.backImageId ?? '';
        message.note = object.note ?? '';
        message.operatorNote = object.operatorNote ?? '';
        message.returnContext = (object.returnContext !== undefined && object.returnContext !== null)
            ? check_return_context_1.CheckReturnContext.fromPartial(object.returnContext)
            : undefined;
        message.holdDurationDays = object.holdDurationDays ?? undefined;
        message.releaseFundsAfterMs = object.releaseFundsAfterMs ?? undefined;
        message.operatorUsername = object.operatorUsername ?? undefined;
        message.operatorActionAtMs = object.operatorActionAtMs ?? undefined;
        message.processedAtMs = object.processedAtMs ?? undefined;
        message.processorTransactionId = object.processorTransactionId ?? undefined;
        message.processor = object.processor ?? CheckProcessor.INVALID_CHECK_PROCESSOR;
        return message;
    },
};
function checkProcessorFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CHECK_PROCESSOR':
            return CheckProcessor.INVALID_CHECK_PROCESSOR;
        case 1:
        case 'URBAN_FT':
            return CheckProcessor.URBAN_FT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CheckProcessor.UNRECOGNIZED;
    }
}
exports.checkProcessorFromJSON = checkProcessorFromJSON;
function checkProcessorToJSON(object) {
    switch (object) {
        case CheckProcessor.INVALID_CHECK_PROCESSOR:
            return 'INVALID_CHECK_PROCESSOR';
        case CheckProcessor.URBAN_FT:
            return 'URBAN_FT';
        case CheckProcessor.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.checkProcessorToJSON = checkProcessorToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-check-deposit.js.map